module.exports = __webpack_public_path__ + "img/heart-filled.1c035706.svg";